import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'hsc-card',
  imports: [CommonModule],
  template: `
    <div
      [ngClass]="{
        'mb-[12px] rounded border p-[12px]': true,
        'bg-gray-300': disabled,
        'bg-red-100': active,
      }"
    >
      @if (title) {
        <div class="flex items-center justify-between pb-[12px]">
          <div class="text-vibrant-blue text-[20px] font-medium">{{ title }}</div>
          @if (active) {
            <span class="text-cherry-red text-[16px] font-bold">Active</span>
          }
          @if (disabled) {
            <span class="text-[16px] font-bold">Disabled</span>
          }
        </div>
      }
      @if (!disabled) {
        <div class="space-y-2">
          <ng-content></ng-content>
        </div>
      }
    </div>
  `,
})
export class Card {
  @Input() title?: string;
  @Input() active?: boolean = false;
  @Input() disabled?: boolean = false;
}
